// import React from 'react';
import { useEffect, useRef } from 'react';
import Typewriter from 'typewriter-effect/dist/core';
import '../../ressources/styles/expertises.css';
import Fleche from '../../ressources/images/fleche.svg';
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import Typography from '@mui/material/Typography';
import SearchBar from '../Carrieres/components/SearchBar';
import AnchorNav from '../Carrieres/components/AnchorNav';

const SQUARE = "w-fit max-w-full sm:max-w-full md:max-w-full mx-auto bg-white border border-gray-200 rounded-lg shadow p-4 sm:p-6 flex flex-col justify-center";

const SECTIONS = [
  { id: "sum",       labelKey: "anchor_summary" },
  { id: "dev",       labelKey: "anchor_developpement" },
  { id: "int",       labelKey: "anchor_integration" },
  { id: "exp",       labelKey: "anchor_expertise" },
];

export default function NotreOffre() {
  const titleRef2 = useRef(null);
  const { t } = useTranslation();
    useEffect(() => {
    const title = titleRef2.current;
    const typewriter = new Typewriter(title, {
    loop: true
    });
    typewriter.typeString(t("offre_savoir"))
    .deleteAll()
    .pauseFor(1500)
    .deleteAll()
    .start(t);
  }, [t]); 
  
  return (
    <>
      <Helmet>
        <title>{t("offre_title")}</title>
      </Helmet>  
      <AnchorNav SECTIONS={SECTIONS}/>
      <div className='flex flex-col justify-center overflow-hidden'>
        <div className='landing-img2 flex items-center justify-center pt-16 max-h-52'>
          <h1 className='text-white font-bold wrapper text-center text-4xl lg:text-6xl mt-8' ref={titleRef2}>{t("offre_savoir")}</h1>
        </div>
        <div className='w-full mt-10 mb-10 text-left wrapper'>
          <div className={`text-left ${SQUARE}`}>
            <Typography>
                <h1 id="sum" className='summary'> {t("notreoffre_00_titre")} </h1>
            </Typography>
            <Typography>
              <a href="#dev">
                <button>
                  <h1 className='big-title-summary'>{t("notreoffre_01_titre")}</h1>
                </button>
              </a>
            </Typography>
            <Typography>
              <a href="#int">
                <button>
                  <h1 className='big-title-summary'> {t("notreoffre_02_titre")}</h1>
                </button>
              </a>
            </Typography>
            <Typography>
              <a href="#exp">
                <button>
                  <h1 className='big-title-summary'>{t("notreoffre_03_titre")}</h1>
                </button>
              </a>
            </Typography>
          </div>
          <div className="mb-40"></div>
          <div className="border-y-2 md:grid-cols-4 md:mt-14 mb-40"></div>
          <Typography>
            <h1 id="dev" className='big-title-accordion scroll-mt-[100px]'>{t("notreoffre_01_titre")}</h1>
          </Typography>
          <Typography>
            <div className='wrapper flex flex-col lg:flex-row gap-[50px] w-full'>
              <div className='flex flex-col w-full lg:w-1/2 gap-8 paragraph'>
                <p>
                <Trans i18nKey="notreoffre_01_paragraphe1" />
                </p>  
                <p>
                <Trans i18nKey="notreoffre_01_paragraphe2" />
                </p>
                <p>
                <Trans i18nKey="notreoffre_01_paragraphe3" />
                </p>
                <p>
                <br></br>
                <Trans i18nKey="notreoffre_01_paragraphe4" />
                </p>
                <p>
                <br></br>
                <Trans i18nKey="notreoffre_01_paragraphe7" />
                </p>
                <br></br>
                <p><Trans i18nKey="notreoffre_01_paragraphe5" /></p>
              </div>
              <div className="div-background"></div>
                <div className='flex flex-col w-full lg:w-1/2  paragraph'>
                  <div className="mb-16 rounded-xl shadow-lg overflow-hidden">
                    <div className="p-8 order-1 md:order-2">
                        <h3 className='text-5xl font-bold text-gray-800 mb-4 md:text-2xl'>{t("notreoffre_01_h3_01")}</h3>
                        <h4 className=''>{t("notreoffre_01_h4")}</h4>
                        <p className="text-gray-600 leading-relaxed mb-4 text-justify">
                          <li><Trans i18nKey="notreoffre_01_li1" /></li>
                          <li><Trans i18nKey="notreoffre_01_li2" /></li>
                          <li><Trans i18nKey="notreoffre_01_li3" /></li>
                          <li><Trans i18nKey="notreoffre_01_li4" /></li>
                          <li><Trans i18nKey="notreoffre_01_li5" /></li>
                          <li><Trans i18nKey="notreoffre_01_li6" /></li>
                          <br></br>
                        </p>
                    </div>
                  </div>
                  <div className="mb-16 rounded-xl shadow-lg overflow-hidden">
                    <div className="p-8 order-1 md:order-2">
                        <h3 className='text-5xl font-bold text-gray-800 mb-4 md:text-2xl'>{t("notreoffre_01_h3_02")}</h3>
                        <h4 className=''>{t("notreoffre_01_h4_02")}</h4>
                        <p className="text-gray-600 leading-relaxed mb-4 text-justify">
                          <li><Trans i18nKey="notreoffre_01_li7" /></li>
                          <li><Trans i18nKey="notreoffre_01_li8" /></li>
                          <li><Trans i18nKey="notreoffre_01_li9" /></li>
                          <li><Trans i18nKey="notreoffre_01_li10" /></li>
                          <li><Trans i18nKey="notreoffre_01_li11" /></li>     
                          <br></br>
                        </p>       
                    </div>
                  </div>
                  <div className="mb-16 rounded-xl shadow-lg overflow-hidden">
                    <div className="p-8 order-1 md:order-2">
                        <h3 className='text-5xl font-bold text-gray-800 mb-4 md:text-2xl'>{t("notreoffre_01_h3_03")}</h3>
                        <h4 className=''>{t("notreoffre_01_h4_03")}</h4>
                        <p className="text-gray-600 leading-relaxed mb-4 text-justify">
                          <li><Trans i18nKey="notreoffre_01_li12" /></li>
                          <li><Trans i18nKey="notreoffre_01_li13" /></li>
                          <li><Trans i18nKey="notreoffre_01_li14" /></li>
                          <li><Trans i18nKey="notreoffre_01_li15" /></li>
                          <li><Trans i18nKey="notreoffre_01_li16" /></li>
                          <li><Trans i18nKey="notreoffre_01_li17" /></li>
                        </p>       
                    </div>
                  </div>
                </div>
            </div>
          </Typography>
          <div className="border-y-2 md:grid-cols-4 md:mt-14 mb-40"></div>
          <Typography>
            <h1 id="int" className='big-title-accordion scroll-mt-[100px]'>{t("notreoffre_02_titre")}</h1>
          </Typography>
          <Typography>
            <div className='wrapper flex flex-col lg:flex-row gap-[50px] w-full'>
              <div className='flex flex-col w-full lg:w-1/2 gap-8 paragraph'>
                  <p>
                    <Trans i18nKey="notreoffre_02_paragraphe1" />
                  </p>  
                  <p>
                    <Trans i18nKey="notreoffre_02_paragraphe2" />
                  </p>
                  <p>
                    <Trans i18nKey="notreoffre_02_paragraphe3" />
                  </p>
                  <p>
                    <Trans i18nKey="notreoffre_02_paragraphe4" />
                  </p>
                  <p>
                    <Trans i18nKey="notreoffre_02_paragraphe5" />
                  </p>
                </div>
          <div className="div-background"></div>
          <div className='flex flex-col w-full lg:w-1/2  paragraph'>
            <div className="mb-16 rounded-xl shadow-lg overflow-hidden">
              <div className="p-8 order-1 md:order-2">
                  <h3 className='text-5xl font-bold text-gray-800 mb-4 md:text-2xl'>{t("notreoffre_02_h3_01")}</h3>
                  <p className="text-gray-600 leading-relaxed mb-4 text-justify">
                    <li><Trans i18nKey="notreoffre_02_li1" /></li>
                    <li><Trans i18nKey="notreoffre_02_li2" /></li>
                    <li><Trans i18nKey="notreoffre_02_li3" /></li>
                    <br></br>
                  </p>
              </div>
            </div>
            <div className="mb-16 rounded-xl shadow-lg overflow-hidden">
              <div className="p-8 order-1 md:order-2">
                  <h3 className='text-5xl font-bold text-gray-800 mb-4 md:text-2xl'>{t("notreoffre_02_h3_02")}</h3>
                  <p className="text-gray-600 leading-relaxed mb-4 text-justify">
                    <li><Trans i18nKey="notreoffre_02_li4" /></li>
                    <li><Trans i18nKey="notreoffre_02_li5" /></li>
                    <li><Trans i18nKey="notreoffre_02_li6" /></li>  
                    <br></br>
                  </p>       
              </div>
            </div>
          </div>
        </div>
          </Typography>
          <div className="border-y-2 md:grid-cols-4 md:mt-14 mb-40"></div>
          <div className="mb-20"></div>
          <Typography>
            <h1 id="exp" className='big-title-accordion scroll-mt-[100px]'>{t("notreoffre_03_titre")}</h1>
          </Typography>
          <Typography> 
            <SearchBar />
              <br></br>
              <p>
                <b> {t("notreoffre_03_paragraphe2")}</b>
              </p>  
          </Typography>
        </div>

        <div className='wrapper flex flex-col lg:flex-row gap-[75px] w-full'>
        </div>

        <Link to='/contact' className='mb-24'  data-aos="fade-up">
          <div className='bg-image flex flex-col justify-center h-52'>
            <h2 className='text-3xl font-bold text-center mb-2 md:text-4xl xl:text-5xl wrapper text-white'>{t("offre_projet1")} <span className='text-primOrange'>{t("offre_projet2")}</span></h2>
            <img src={Fleche} alt="fleche" className='anim-fleche h-24' />
          </div>
        </Link>
      </div>
      </>
  )
}